// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"637":"65e2b6be","647":"6f497653"}[chunkId] + ".chunk.css";
};